"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BooleanAsNumber = void 0;

/**
 * This "type" parses a boolean value represented as a stringified "1" or "0" to a bool
 * @param val
 * @constructor
 */
var BooleanAsNumber = function BooleanAsNumber(val) {
  return Boolean(Number(val));
};
/**
 * Reverts a Boolean to it's native format
 * @param v
 * @returns {String}
 * @constructor
 */


exports.BooleanAsNumber = BooleanAsNumber;

BooleanAsNumber.Out = function (v) {
  return v ? '1' : '0';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/types/BooleanAsNumber.js
// module id = 28
// module chunks = 0